import React from 'react';
import PropTypes from 'prop-types';
import app from 'general/js/app';
import gtm from 'general/js/gtm';
import { themeNames } from 'components/news-feed/js/enums';

class SocialCard extends React.Component {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
    }

    componentDidMount() {
        this.rootRef.current.addEventListener('click', this.onClickRoot);
    }

    componentWillUnmount() {
        this.rootRef.current.removeEventListener('click', this.onClickRoot);
    }

    onClickRoot = (event) => {
        const label = `${this.getFullTitle()} > ${window.location.href}`;
        gtm.push('Social Post', 'Click', label);

        if (app.isEditMode) {
            event.preventDefault();
        }
    }

    getFullTitle() {
        const { title, subtitle } = this.props.model;
        return title + (subtitle ? ` / ${subtitle}` : '');
    }

    getIconCssName(theme) {
        switch (theme) {
            case themeNames.TWITTER:
                return 'twitter';
            case themeNames.INSTAGRAM:
                return 'instagram';
            case themeNames.FACEBOOK:
                return 'facebook';
            default:
                return '';
        }
    }

    renderArticle(model) {
        let template = null;

        if (model.theme !== themeNames.INSTAGRAM) {
            template = (
                <div className="social-card__article">
                    <span className="social-card__article-text">{model.description}</span>
                </div>
            );
        } else {
            template = null;
        }

        return template;
    }

    renderTheme(model) {
        const iconCssName = this.getIconCssName(model.theme);

        if (!iconCssName) return null;

        return (
            <div className="social-card__theme-icon">
                <svg
                    className={`social-card__icon social-card__icon--${model.theme.toLowerCase()} icon`}
                    width="24px" height="24px" focusable="false">
                    <use xlinkHref={`#icon-${iconCssName}`}></use>
                </svg>
            </div>
        );
    }

    render() {
        const { model, bemModifiers } = this.props;
        let bemCss = '';

        if (Array.isArray(bemModifiers)) {
            bemCss = bemModifiers.map((x) => `social-card--${x}`).join(' ');
        }

        return (
            <a
                className={`social-card ${bemCss}`}
                href={model.url}
                ref={this.rootRef}
                onClick={this.onClickRoot}
            >
                <div className="social-card__background">
                    <img
                        className="lazyload"
                        data-srcset={model.bgImage}
                        alt=""
                        data-sizes="auto"
                    />
                </div>
                <div className="social-card__content-wrapper">
                    <div className="social-card__content">
                        <div className='social-card__content-article'>
                            <div className='social-card__theme-wide'>
                                {this.renderTheme(model)}
                            </div>
                            <div className="social-card__article-wrapper">
                                <div className="social-card__theme">
                                    {this.renderTheme(model)}
                                </div>
                                <h3 className="social-card__title">
                                    <b>{model.title}</b>
                                    <span> {model.subtitle}</span>
                                </h3>
                                {this.renderArticle(model)}
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        );
    }
}

SocialCard.propTypes = {
    model: PropTypes.object.isRequired,
    bemModifiers: PropTypes.array
};

export default SocialCard;
